import classNames from 'classnames'
import { useApp } from '../../../hooks/useApp'
import { getMainProductVariantById } from '../../../utils'

interface Props {
  className?: string
}

export const SelectedVariantHeroImage = ({ className }: Props) => {
  const { mainProduct, activeMainProductVariantId } = useApp()
  const activeMainProductVariant = getMainProductVariantById(mainProduct, activeMainProductVariantId)

  const heroImageUrl = activeMainProductVariant.gallery?.[0]
    || activeMainProductVariant.featuredImageUrl
    || activeMainProductVariant.featured_image.src
    || mainProduct.featured_image

  if (!heroImageUrl) {
    return null
  }

  return (
    <img
      className={classNames('rounded-sm w-full h-auto bg-[#f8f7f5] xl:sticky xl:top-20 xl:bg-[#f2f1ed] aspect-[4/5]', className)}
      src={heroImageUrl}
      alt={activeMainProductVariant.metafields.title || activeMainProductVariant.title}
    />
  )
}